<template>
  <div v-html="html" />
</template>
<script>
import {postAction,getAction } from '@/api/manage'
export default {
  name: 'heartAlipay',
  data(){
    return {
      html:'',
      name:'',
      filename:'',
    }
  },
  computed:{
    weiboid() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.$store.getters.getweiboid || '';
    },
    code(){
      return this.$route.query.code ? this.$route.query.code : ''
    },
    name(){
      return this.$route.query.name || ''
    },
    filename(){
      return this.$route.query.filename || ''
    }
  },
  created() {
    this.init()
  },
  mounted(){
    if(!this.weiboid){
        if(!this.code){
          var url = encodeURIComponent(window.location.protocol+"//"+window.location.hostname+ '/heartAlipay')
          window.location.href=`https://api.weibo.com/oauth2/authorize?client_id=3852406503&response_type=code&redirect_uri=`+ url
        }else {
          this.getJsLogin()
        }
    } else {
      this.alipayPayClick()
    }
  },
  methods:{
    init() {
      // 从路由查询参数中读取 name 和 filename
      this.name = this.$route.query.name || '';
      this.filename = this.$route.query.filename || '';

      // 验证 name 和 filename 是否存在
      if (!this.name || !this.filename) {
        alert('name 或 filename 不存在，请重新上传图片并输入名称');
        this.$router.push('/heartresultweibo'); // 重定向到之前的页面或其他页面
      }
    },
    alipayPayClick(){
        // 页面传参
        const url = '/wbfunc/total/alppay/start'
        postAction(url,
        {
          name:this.name,
          filename:this.filename,
          weiboid:this.weiboid,
          goodType:'心动吗',
          price:5.2,
          return_url:`https://online.miaoxingjundd.com/heartresultweibo?paytrue=1&weiboid=${this.weiboid}&filename=${this.filename}&name=${this.name}`,
         }).then(res => {
          this.html = res.data.data.form;
          //渲染支付宝支付页面
          this.$nextTick(() =>
            document.forms[0].submit()
          )
        })
      }
    },
    getJsLogin(){
        const url = '/wbfunc/wblogin'
        postAction(url, {code:this.code}).then( res => {
          this.userInfo = res.data.data
          this.$store.commit("setweiboid", this.userInfo.id);
          this.$store.commit("setweiboname", this.userInfo.name);
          this.$store.commit("setweiboimg", this.userInfo.cover_image_phone);
          this.$store.commit("setweibofoll", this.userInfo.followers_count);
          this.$store.commit("setweibodomin", this.userInfo.description);
        })
    }
  }

</script>
